<div
  fxFlex
  fxLayout="column"
  class="push"
  [class.pointer]="auth.admin"
  (click)="openPaymentPage()"
>
  <span class="payment-widget__info push-bottom-sm" i18n
    >Available: {{ availableCount }}</span
  >
  <span class="payment-widget__info" i18n>Paid: {{ paidCount }}</span>
</div>
